import {useMmsService} from "services/mms/context/MmsServiceContext.tsx";
import {useEffect} from "react";
import { Box } from "@mui/material"
import {DashboardCardInfo} from "components/dashboard/cardInfo.tsx";
import { GaugeType } from "types/dashboard.ts";

interface DasboardCardInfoProps {
    startDate: Date
    endDate: Date
}

export const DashboardInfo: React.FC<DasboardCardInfoProps> = ({startDate, endDate}) => {
    const { sessionsService,} = useMmsService()
    const { useGetTotalRefillSession, useGetAverageTime, useGetAverageKilowatt, useGetTotalKilowatt } = sessionsService

    const {data : totalRefillSession, sendRequest: fetchTotalRefillSession, isLoading: totalRefillLoading} = useGetTotalRefillSession(startDate, endDate)
    const {data : averageTimeSession, sendRequest: fetchAverageTimeSession, isLoading: averageTimeLoading} = useGetAverageTime(startDate.toString(), endDate.toString())
    const {data : averageKilowatt, sendRequest: fetchKilowatt, isLoading: averageKilowattLoading} = useGetAverageKilowatt(startDate, endDate)
    const {data : totalKilowatts, sendRequest: fetchTotalKilowatts, isLoading: totalKilowattLoading} = useGetTotalKilowatt(startDate, endDate)

    useEffect(() => {
        fetchTotalRefillSession()
        fetchAverageTimeSession()
        fetchKilowatt()
        fetchTotalKilowatts()
    }, [startDate, endDate])

    return(
        <Box sx={{display: "flex", flexDirection: "column", gap:'0.5rem', alignItems: 'center', width: '100%', height: '100%'}}>
            <Box sx={{display: "flex", flexDirection: "row", gap:'0.5rem', alignItems: 'center', width: '100%', height: '100%'}}>
                {
                    !totalRefillLoading && (<DashboardCardInfo background={true} title={"Nombre total de sessions de recharges"} value={totalRefillSession ? totalRefillSession.toString() : undefined} />)
                }
                {
                    !averageKilowattLoading  && (<DashboardCardInfo background={true} gaugeType={GaugeType.Gauge} title={"Nombre de kWh moyen délivré par recharge"} value={averageKilowatt ? averageKilowatt.toString() : undefined} />)
                }
            </Box>
            <Box sx={{display: "flex", flexDirection: "row", gap:'0.5rem', alignItems: 'center', width: '100%', height: '100%'}}>
                {
                    !totalKilowattLoading  && (<DashboardCardInfo background={true} gaugeType={GaugeType.Gauge} title={"Nombre total de kWh délivrés"} value={totalKilowatts ? totalKilowatts.toString() : undefined} />)
                }
                {
                    !averageTimeLoading  && (<DashboardCardInfo background={true} gaugeType={GaugeType.Chrono} title={"Durée moyenne d'une session de recharge"} value={averageTimeSession ? averageTimeSession.toString() : undefined} />)
                }
            </Box>
        </Box>
    )
}